module.exports = __webpack_public_path__ + "assets/img/e937846f654052feffe48f84c849bbef.png";